<template>
	<BaseWebshopCart v-slot="{total}">
		<div class="wc-fixed-bar">
			<template v-if="props.mode == 'cart'">
				<div class="wc-fixed-totals"><BaseUtilsFormatCurrency :price="total.total_items_total" /></div>

				<BaseWebshopCartErrors v-slot="{errors, errorsItems}">
					<BaseUtilsAppUrls v-slot="{items}">
						<div v-if="errors || errorsItems" class="btn btn-fixed-bar btn-green btn-cart-box btn-icon-arrow btn-disabled"><BaseCmsLabel code="checkout" tag="span" /></div>
						<NuxtLink v-else :to="items.webshop_customer" @click="cartBeginCheckout()" class="btn btn-fixed-bar btn-green btn-cart-box btn-icon-arrow"><BaseCmsLabel code="checkout" tag="span" /></NuxtLink>
					</BaseUtilsAppUrls>
				</BaseWebshopCartErrors>
			</template>
			<template v-else>
				<template v-if="props.mode == 'total_full'">
					<div class="wc-fixed-totals"><BaseUtilsFormatCurrency :price="total.total_regular" /></div>
				</template>
				<template v-else>
					<div class="wc-fixed-totals"><BaseUtilsFormatCurrency :price="total.total_items_total" /></div>
				</template>

				<button v-if="checkoutLoading || creation" class="btn btn-green btn-cart-box btn-icon-arrow btn-submit btn-fixed-bar btn-spinner"></button>
				<div v-else-if="(customer && !meta?.valid) || (!customer && (!meta?.valid || !formValid))" class="btn btn-fixed-bar btn-green btn-cart-box btn-icon-arrow btn-submit btn-disabled">
					<span v-if="review"><BaseCmsLabel code="confirm_order" /></span>
					<span v-else><BaseCmsLabel code="wc_next_step" /></span>
				</div>
				<button v-else class="btn btn-fixed-bar btn-green btn-cart-box btn-icon-arrow btn-submit" type="submit">
					<span v-if="review"><BaseCmsLabel code="confirm_order" /></span>
					<span v-else><BaseCmsLabel code="wc_next_step" /></span>
				</button>
			</template>
		</div>
	</BaseWebshopCart>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['review', 'customer', 'mode', 'meta']);
	const gtm = useGtmBB();
	const { checkoutLoading, formValid, creation } = useCheckout();

	//begin checkout
	function cartBeginCheckout() {
		gtm.beginCheckout()
	}
</script>

<style lang="less" scoped>
	.wc-fixed-bar{
		display: none; align-items: center; padding: 10px 15px; background: @white; position: fixed; bottom: 0; left: 0; right: 0; box-shadow: 0 0 20px 0 rgba(0,37,69,0.2); z-index: -1;

		@media (max-width: @m){display: flex; justify-content: space-between; z-index: 1111;}
	}
	.wc-fixed-totals{font-size: 20px; font-weight: 600;}
	.btn-fixed-bar{
		display: inline-flex; min-width: 180px; height: 50px; padding: 0 30px; font-size: 15px;
		span:before{font-size: 9px; top: 6px;}
	}
</style>
